import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import img from "../Images/Jayraj_logo.png"
import "../Styles/TourOverview.css";
import "../Styles/PackageTourDetails.css";
import {
    FaCalendarAlt,
    FaClock,
    FaChevronDown,
    FaChevronUp,
} from "react-icons/fa";
import Navber from "./Navber";
import Building from "../Images/Building.png";
import Van from "../Images/Van.png";
import Cablecar from "../Images/CableCar.png";
import NavigationArrow from "../Images/NavigationArrow.png";
import Travelers_favorite from "./Travelers_favorite";
import User_Destinations from "./User_Destinations";
import Typemsg from "./Typemsg";
import Why_travel_with_us from "./Why_travel_with_us";
import api from "../Api.js";
import Slider from "react-slick";
import DOMPurify from "dompurify";
import SafeMap from "./Safemap.jsx";
import { FormControl, InputLabel, Select } from '@mui/material'
import {
    Modal,
    Backdrop,
    Checkbox,
    Fade,
    Box,
    Button,
    IconButton,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    Snackbar,
    Alert,
    TextField,
    MenuItem,
    CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { showToast } from "../Components/PopupMessage.jsx";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar, PickersDay } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";

import { useContext } from "react";
import { BookmarkedContext } from "../Context/BookmarkedContext.jsx";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CIcon from '@coreui/icons-react';
import { cilClock } from '@coreui/icons';
import { SlArrowDown, SlArrowUp } from "react-icons/sl";
import ImageLightbox from "./Helping Component/ImageZoom.jsx";



function SafeComponent({ html }) {
    const cleanHTML = DOMPurify.sanitize(html);
    return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
}

const CustomDay = styled(PickersDay, {
    shouldForwardProp: (prop) => prop !== "isAvailable" && prop !== "isSelected",
})(({ theme, isAvailable, isSelected }) => ({
    borderRadius: "50%",

    ...(isAvailable && {
        "&::after": {
            content: '""',
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: "green",
            position: "absolute",
            bottom: 1,
        },
    }),

    ...(isSelected && {
        backgroundColor: "green !important",
        color: "white !important",
    }),
}));





function PackageTourDetails() {
    const { id } = useParams();
    console.log("Group Tour ID: ", id);
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(null);
    const [showMoreDesc, setShowMoreDesc] = useState(false);

    const [tourData, setTourData] = useState({});
    const [tourPriceData, setTourPriceData] = useState({});
    const [activities, setActivities] = useState([]);
    const [tourImages, setTourImages] = useState([]);
    const [tourVideos, setTourVideos] = useState([]);
    const [itininerary, setItinerary] = useState([]);
    const [showPrice, setShowPrice] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const accessToken = localStorage.getItem("accessTok");
    const customer_data = JSON.parse(localStorage.getItem("customer"));
    const [tourOnlyPrice, setTourOnlyPrice] = useState(0);
    const [groupDepartureDates, setGroupDepartureDates] = useState([]);
    const [packageType, setPackageType] = useState("basic");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [travellers, setTravellers] = useState([{ name: "", age: "", type: "adult" }]);
    const { addBookmark, removeBookmark, isBookmarked, bookmarkedItems } = useContext(BookmarkedContext);
    const [selectedDate, setSelectedDate] = useState(null);
    const availableDates = tourData?.dates?.group?.departure_dates || [];
    const [transportData, setTransportData] = useState([]);
    const [showAll, setShowAll] = useState(false);
    // MODAL FOR PASSENGER DETAILS
    const [openPassengerModal, setOpenPassengerModal] = useState(false);

    // Store Passenger Details Dynamically
    const [passengerDetails, setPassengerDetails] = useState([]);



    // Package Type: Basic / Standard / Premium
    const [selectedPackage, setSelectedPackage] = useState("Basic");

    // Travellers
    const [adults, setAdults] = useState(1);
    const [children, setChildren] = useState(0);
    const [infants, setInfants] = useState(0);

    // Calculated Price
    const [finalPrice, setFinalPrice] = useState(0);
    const [selectedHotelPrices, setSelectedHotelPrices] = useState([]);
    const [selectedTransport, setSelectedTransport] = useState([]);
    // Extra pricing (default 0 until added)
    const [adultExtra, setAdultExtra] = useState(0);
    const [childExtra, setChildExtra] = useState(0);
    const [infantExtra, setInfantExtra] = useState(0);
    const [hotelId, setHotelId] = useState(null);
    const [roomId, setRoomlId] = useState(null);
    const [transportId, setTransportId] = useState([]);
    const [transportPrice, setTransportPrice] = useState(0);
    const [showAllMonths, setShowAllMonths] = useState(false);
    const activitySectionRef = useRef(null);
    const [activityPrice, setActivityPrice] = useState(0);
    // Upgrade modal
    const [openUpgradeModal, setOpenUpgradeModal] = useState(false);

    // Selected upgrades (checkbox)
    const [selectedUpgrades, setSelectedUpgrades] = useState([]);






    const toggleDay = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };






    function calculateNights(checkIn, checkOut) {
        if (!checkIn || !checkOut) return 0;
        const inDate = new Date(checkIn);
        const outDate = new Date(checkOut);
        const diffTime = outDate.getTime() - inDate.getTime();
        const nights = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        return nights + 1;
    }



    useEffect(() => {
        const handleTourOverview = async () => {
            try {
                const response = await api.get(`/tours/${id}/details`);
                if (response?.data?.success === true) {
                    setItinerary(response?.data?.data?.itineraries || []);
                    setTourData(response?.data?.data?.tour);
                    setTourPriceData(response?.data?.data);
                    setAdultExtra(response?.data?.data?.computed_totals?.adult_extra || 0);
                    setChildExtra(response?.data?.data?.computed_totals?.child_extra || 0);
                    setInfantExtra(response?.data?.data?.computed_totals?.infant_extra || 0);
                    setActivities(response?.data?.data?.tour?.activities || []);
                    setTotalPrice(
                        response?.data?.data?.tour?.pricing?.stored_totals?.total_price_basic || tourData?.pricing?.per_person?.adult
                    );
                    setTourImages(response?.data?.data?.photos || []);
                    setTourVideos(response?.data?.data?.videos?.[0] || []);
                }
            } catch (error) {
                console.error("Error fetching tour data: ", error);
            }
        };
        handleTourOverview();
    }, [id]);


    const calculateTotalPrice = () => {
        if (!tourPriceData?.displays) return;

        let total = tourPriceData?.tour?.raw_columns?.mrp_group
            ;
        const extrachild = tourPriceData?.tour?.raw_columns?.child_price
        const totalPeople = adults + children;
        if (tourData?.counts?.total_seat < totalPeople) {
            showToast(`Maximum seat is ${tourData?.counts?.total_seat}`, "error");
            return;
        }

        const activityTotal = calculateActivityTotal();

        setActivityPrice(activityTotal);
        const upgradeTotal = calculateUpgradeTotal();

        let final =
            total * adults +
            extrachild * children +
            activityTotal +
            upgradeTotal;

        setFinalPrice(final);

        setFinalPrice(final);
    };




    const updatePassenger = (index, field, value) => {
        const updated = [...passengerDetails];
        updated[index][field] = value;
        setPassengerDetails(updated);
    };






    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "none", background: "red" }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "none", background: "green" }}
                onClick={onClick}
            />
        );
    }

    const settings = {
        customPaging: function (i) {
            return (
                <a>
                    <img
                        src={tourData?.images[i].url}
                        alt={`thumb-${i}`}
                        className="carousel-thumbnail"
                    />
                </a>
            );
        },
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        fade: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };

    const getSelectedUpgradesPayload = () => {
        return upgrades
            .map((u, i) => ({
                title: u.title,
                quantity: upgradeCounts[i] || 0,
                price: Number(u.price),
            }))
            .filter(u => u.quantity > 0);
    };
    const checkSeatAvailability = async (date) => {
        try {
            const response = await api.get("/group-tour-seat-status", {
                params: {
                    tour_id: id,
                    date: date.format("YYYY-MM-DD"),
                },
            });

            if (response.data.success) {
                return response.data.data.available_seats;
            }

            return 0;
        } catch (error) {
            console.error("Seat check error:", error);
            return 0;
        }
    };



    const handleConfirmBooking = async () => {
        if (!accessToken) {
            showToast("please Login to book Tour", "error")
            navigate("/signup")
            return
        }
        if (!selectedDate) {
            showToast("Please select a start date", "error");
            return;
        }

        // Validate passenger details
        for (let i = 0; i < passengerDetails.length; i++) {
            const p = passengerDetails[i];

            if (!p.name || !p.age || !p.type) {
                showToast("Please fill all passenger basic details", "error");
                return;
            }

            // First passenger must have email & phone
            if (i === 0) {
                if (!p.email || !p.phone) {
                    showToast("First passenger email and phone are required", "error");
                    return;
                }

                // Optional: Email format validation
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(p.email)) {
                    showToast("Please enter valid email address", "error");
                    return;
                }

                // Optional: Indian phone validation
                const phoneRegex = /^[6-9]\d{9}$/;
                if (!phoneRegex.test(p.phone)) {
                    showToast("Please enter valid 10 digit phone number", "error");
                    return;
                }
            }
        }

        const totalPassenger = adults + children + infants
        if (totalPassenger > Number(tourData?.counts?.total_seat)) {
            showToast(`Maximum seat is ${tourData?.counts?.total_seat}`, "error");
            return;
        }


        const latestAvailableSeats = await checkSeatAvailability(selectedDate);

        if (totalPassenger > latestAvailableSeats) {
            showToast(
                `Only ${latestAvailableSeats} seats available for selected date`,
                "error"
            );
            return;
        }
        const endDate = dayjs(selectedDate).add(tourData.raw_columns.no_of_days, "day").format("YYYY-MM-DD");
        console.log("end date", endDate);
        const Activities = getSelectedActivitiesPayload();
        console.log("Selected Activities Payload:", Activities);
        const admintoken = localStorage.getItem("accessTok");
        console.log("Admin token:", admintoken);


        const payload = {
            tour_id: id,
            customer_id: null,
            meta: {
                package_type: selectedPackage
            },
            start_date: selectedDate?.format("YYYY-MM-DD"),
            adult_count: adults,
            child_count: children,
            infant_count: infants,
            total_amount: finalPrice,
            passengers: passengerDetails,
            transport_id: transportId,
            hotel_id: hotelId,
            room_id: roomId,
            no_of_room: selectedHotelPrices.reduce((sum, h) => sum + h.rooms, 0) || 1,
               tour_end_date: endDate,
            group_departure_dates_input: [selectedDate?.format("YYYY-MM-DD")],
            activities: Activities,
            upgrades: myUpgrade
        };
        console.log  ("Booking Payload:", payload);

        try {
            setLoading(true);

            const response = await api.post("/admin/bookings/tour", payload, {
                headers: {
                    "X-ADMIN-TOKEN": `${admintoken}`,
                }
            });
            console.log("Booking Response:", response.data);

            if (response.data.status === true) {
                showToast("Booking created Successfully!", "success");
                setOpenPassengerModal(false);

                navigate(`/tour-review/${response?.data?.data?.tour_id}`, {
                    state: { bookingDetails: response?.data?.data },
                });
            } else {
                showToast(response.data.message || "Booking failed", "error");
            }
        } catch (error) {
            console.error(error);
            showToast("Server error while booking", "error");
        } finally {
            setLoading(false);
        }
    };

    const groupedDepartures = {};

    availableDates.forEach((d) => {
        const date = dayjs(d);
        const year = date.format("YYYY");
        const month = date.format("MMM");

        if (!groupedDepartures[year]) groupedDepartures[year] = {};
        if (!groupedDepartures[year][month]) groupedDepartures[year][month] = [];

        groupedDepartures[year][month].push(d);
    });


    const activitySlider = {
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 3,       // default for large screens
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024, // <= 1024px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 768, // <= 768px
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const [seatCounts, setSeatCounts] = useState({});

    const calculateActivityTotal = () => {
        return activities.reduce((total, activity) => {
            const qty = seatCounts[activity.id] || 0;
            const price = Number(activity.price) || 0;
            return total + qty * price;
        }, 0);
    };
    const getSelectedActivitiesPayload = () => {
        return activities
            .filter(a => seatCounts[a.id] > 0)   // only selected ones
            .map(a => ({
                activity_id: a.id,
                quantity: seatCounts[a.id],
                price: Number(a.price)
            }));
    };


    const handleAddClick = (id) => {
        setSeatCounts((prev) => {
            const newCount = (prev[id] || 0) + 1;

            showToast(`Activity added (${newCount})`, "success");

            return {
                ...prev,
                [id]: newCount,
            };
        });
    };


    const handleRemoveClick = (id) => {
        setSeatCounts((prev) => {
            const currentCount = prev[id] || 0;
            const newCount = currentCount > 0 ? currentCount - 1 : 0;

            showToast(`Activity removed (Remain: ${newCount})`, "warn");

            return {
                ...prev,
                [id]: newCount,
            };
        });
    };

    useEffect(() => {
        calculateTotalPrice();
    }, [seatCounts]);


    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 300) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);


    const upgrades = tourData?.raw_columns?.upgrades || [];



    const [upgradeCounts, setUpgradeCounts] = useState({});

    const increaseUpgrade = (index) => {
        setUpgradeCounts((prev) => ({
            ...prev,
            [index]: (prev[index] || 0) + 1,
        }));
    };
    const decreaseUpgrade = (index) => {
        setUpgradeCounts((prev) => {
            if (!prev[index]) return prev;

            const updated = { ...prev };
            if (updated[index] === 1) {
                delete updated[index]; // remove when count is 0
            } else {
                updated[index] -= 1;
            }
            return updated;
        });
    };

    const calculateUpgradeTotal = () => {
        if (!upgrades || upgrades.length === 0) return 0;

        return upgrades.reduce((total, upgrade, index) => {
            const qty = upgradeCounts[index] || 0;
            const price = Number(upgrade.price) || 0;
            return total + qty * price;
        }, 0);
    };
    const myUpgrade = getSelectedUpgradesPayload();
    console.log(" the selected upgrade are ", myUpgrade);


    useEffect(() => {
        calculateTotalPrice();
    }, [adults, children, infants, selectedPackage, tourData, upgradeCounts]);



    // seat availability
    const [isSeatInitialized, setIsSeatInitialized] = useState(false);
    const [AvailableSeatNumber, setAvailableSeatNumber] = useState(null)

    useEffect(() => {
        if (availableDates.length > 0 && !isSeatInitialized) {
            const firstDate = dayjs(availableDates[0]);
            setSelectedDate(firstDate);
            setIsSeatInitialized(true);
        }
    }, [availableDates, isSeatInitialized]);

    const fetchAvailableSeats = async (date) => {
        if (!date) return;

        try {
            setLoading(true);

            const response = await api.get(
                `/group-tour-seat-status`,
                {
                    params: {
                        tour_id: id,
                        date: date.format("YYYY-MM-DD")
                    }
                }
            );

            console.log("Available Seat Response:", response.data);
            setAvailableSeatNumber(response?.data?.data?.available_seats);

            // Example:
            // setAvailableSeatCount(response.data.available_seats);

        } catch (error) {
            console.error("Seat API error:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (selectedDate) {
            fetchAvailableSeats(selectedDate);
        }
    }, [selectedDate]);



    return (
        <div style={{ fontFamily: " Quicksand, sans-serif" }}>
            <div style={{ backgroundColor: "#f0f0f0" }}>
                <Navber />
            </div>



            {/* --- MAIN CONTENT BELOW --- */}
            <div className="travel-card">
                <div className="travel-card-image">
                    <Slider {...settings}>
                        {tourData?.images?.map((imgSrc, index) => (
                            <div key={index}>
                                <img src={imgSrc?.url} alt={`tour-${index}`} className="travel-card-image_img" />
                            </div>
                        ))}
                    </Slider>

                    <h3 style={{ marginTop: "30px", fontSize: "2rem" }}>Services</h3>
                    <div
                        style={{ display: "flex", justifyContent: "center" }}
                        className="service_icons"
                    >
                        {[{ img: Building, label: "Hotel" },
                        { img: Van, label: "Transport" },
                        { img: Cablecar, label: "Activity" },
                        { img: NavigationArrow, label: "Itinerary" }].map((item, i) => (
                            <span
                                key={i}
                                style={{
                                    width: "70px",
                                    height: "70px",
                                    borderRadius: "50%",
                                    padding: "20px",
                                    backgroundColor: "black",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "20px",
                                    alignItems: "center",
                                    fontWeight: "600",
                                    color: "white",
                                }}
                            >
                                <img src={item.img} height="100%" width="100%" />
                                <span>{item.label}</span>
                            </span>
                        ))}
                    </div>
                    <div className="action-buttons-container">

                        {/* BOOK NOW BUTTON */}
                        <button
                            className="action-btn action-btn-book"
                            onClick={() => {
                                const totalTravellers = adults + children + infants;

                                setPassengerDetails(
                                    Array.from({ length: totalTravellers }, () => ({
                                        name: "",
                                        age: "",
                                        type: "adult",
                                        email: "",
                                        phone: "",
                                    }))
                                );


                                setOpenPassengerModal(true);
                            }}
                        >
                            Book Now
                        </button>

                        {/* BOOKMARK BUTTON */}
                        <button
                            className="action-btn action-btn-bookmark"
                            onClick={() => {
                                isBookmarked(tourData?.id)
                                    ? removeBookmark(tourData?.id)
                                    : addBookmark({
                                        ...tourData,
                                        finalPrice: finalPrice
                                    });
                            }}
                        >
                            {isBookmarked(tourData?.id) ? "Bookmarked" : "Add to Bookmark"}
                        </button>

                    </div>


                </div>

                {/* RIGHT CONTENT */}
                <div className="travel-card-content">
                    <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", alignItems: "center", gap: "10px" }}>
                        <h3 className="travel-title">{tourData?.title}</h3>
                        <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                            <h3 className="travel-price">₹{tourData?.raw_columns?.mrp_group}/person</h3>
                        </div>

                    </div>
                    {/* DESCRIPTION WITH SHOW MORE / SHOW LESS */}
                    <div>
                        {/* Only 3 lines when collapsed */}
                        <div className={!showMoreDesc ? "description-clamp" : ""}>
                            {/* <SafeComponent html={tourData?.raw_columns?.description} /> */}

                            {tourData?.raw_columns?.overview &&
                                <p><strong>Overview: </strong>{tourData?.raw_columns?.overview}</p>}
                            <SafeComponent html={tourData?.raw_columns?.description} />
                        </div>

                        {/* Toggle Button */}
                        {tourData?.description && (
                            <span
                                className="show-toggle"
                                onClick={() => setShowMoreDesc(!showMoreDesc)}
                            >
                                {showMoreDesc ? <span style={{ backgroundColor: "lightgray", borderRadius: "10px", padding: "4px" }}>Show less <SlArrowUp size={15} /></span> : <span style={{ backgroundColor: "lightgray", borderRadius: "10px", padding: "4px" }}>Show more <SlArrowDown size={15} /></span>}
                            </span>
                        )}
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between", gap: "2px", alignItems: "center", width: "100%", color: "green", fontWeight: "600" }}>
                        <div style={{ width: "100%" }}>Total Seats: {tourData?.counts?.total_seat}</div>
                        <div className="travel-info-left" style={{ width: "100%" }}>
                            <CIcon icon={cilClock} width="15px" />
                            <span>
                                {tourData?.no_of_days || "0"} days
                            </span>
                        </div>
                        <div style={{ width: "100%", color: "red" }}>Available Seat: {AvailableSeatNumber}</div>
                    </div>





                    {/* TOUR START DATE */}
                    <div className="tour-date-section">
                        <div style={{ display: 'flex', justifyContent: "space-between", width: "100%" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", alignItems: "center", width: "100%" }}>
                                <div className="traveller-title">
                                    Select Start Date:{" "}
                                    {selectedDate ? selectedDate.format("DD MMM YYYY") : "Not Selected"}
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>

                                    {activities.length > 0 && <button
                                        className="action-btns"
                                        onClick={() => {
                                            activitySectionRef.current?.scrollIntoView({
                                                behavior: "smooth",
                                                block: "start"
                                            });
                                        }}
                                    >
                                        +Add Activities
                                    </button>}
                                </div>

                            </div>


                        </div>



                        <div className="departure-container">

                            {Object.keys(groupedDepartures).map((year) => (
                                <div key={year} className="departure-year-block">

                                    <div className="departure-year-label">Y {year}</div>

                                    {Object.keys(groupedDepartures[year]).map((month) => (
                                        <div key={month} className="departure-month-block">

                                            <div className="departure-month-label">{month}</div>

                                            <div className="departure-dates-grid">
                                                {groupedDepartures[year][month].map((date, index) => {
                                                    const dateObj = dayjs(date);
                                                    const isActive =
                                                        selectedDate &&
                                                        selectedDate.format("YYYY-MM-DD") === dateObj.format("YYYY-MM-DD");

                                                    return (
                                                        <button
                                                            key={index}
                                                            className={`departure-date-btn ${isActive ? "active" : ""}`}
                                                            onClick={() => setSelectedDate(dateObj)}
                                                        >
                                                            {dateObj.format("D")}
                                                        </button>
                                                    );
                                                })}
                                            </div>

                                        </div>
                                    ))}

                                </div>
                            ))}

                        </div>



                    </div>



                    {/* TRAVELLER INPUTS */}
                    <div className="traveller-section">
                        <div style={{ fontSize: "1.2rem", fontWeight: "700", color: "green" }}>Total Amount: ₹{finalPrice}</div>
                        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                            <span style={{ fontWeight: "800", color: "orange", fontSize: "1.2rem" }}> 🆕Upgrade your tour</span>
                            <button
                                style={{
                                    border: "none",
                                    borderRadius: "10px",
                                    color: "green",
                                    textDecoration: "underline",
                                    background: "transparent",
                                    cursor: "pointer"
                                }}
                                onClick={() => setOpenUpgradeModal(true)}
                            >
                                + Add Details
                            </button>


                        </div>


                        <Modal
                            open={openUpgradeModal}
                            onClose={() => setOpenUpgradeModal(false)}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                        >
                            <Fade in={openUpgradeModal}>
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",

                                        // 🔥 Responsive width
                                        width: {
                                            xs: "95%",     // mobile
                                            sm: "85%",     // tablet
                                            md: "70%",     // small desktop
                                            lg: "60%",     // large desktop
                                        },

                                        maxWidth: 700,
                                        maxHeight: "90vh",
                                        overflowY: "auto",

                                        bgcolor: "background.paper",
                                        borderRadius: 3,
                                        boxShadow: 24,

                                        p: {
                                            xs: 2,
                                            sm: 3,
                                            md: 4,
                                        },
                                    }}
                                >
                                    {/* Header */}
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        mb={2}
                                    >
                                        <Typography variant="h6">Upgrade Your Tour</Typography>
                                        <IconButton onClick={() => setOpenUpgradeModal(false)}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>

                                    {/* Empty State */}
                                    {upgrades.length === 0 && (
                                        <Typography sx={{ mt: 2 }}>No upgrades available</Typography>
                                    )}

                                    {/* Upgrade Items */}
                                    {upgrades.map((upgrade, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                justifyContent: "space-between",
                                                alignItems: { xs: "flex-start", sm: "center" },
                                                gap: 1.5,
                                                mt: 2,
                                                borderBottom: "1px solid #eee",
                                                pb: 1.5,
                                            }}
                                        >
                                            {/* Title */}
                                            <Typography fontWeight={500}>
                                                {upgrade.title}
                                            </Typography>

                                            {/* Price + Counter */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                    width: { xs: "100%", sm: "auto" },
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <Typography>₹{upgrade.price}/person</Typography>

                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => decreaseUpgrade(index)}
                                                    >
                                                        −
                                                    </Button>

                                                    <Typography minWidth={20} textAlign="center">
                                                        {upgradeCounts[index] || 0}
                                                    </Typography>

                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => increaseUpgrade(index)}
                                                    >
                                                        +
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    ))}

                                    {/* Total */}
                                    <Box sx={{ mt: 3 }}>
                                        <Typography fontWeight="bold" fontSize={18}>
                                            Upgrade Total: ₹{calculateUpgradeTotal()}
                                        </Typography>
                                    </Box>

                                    {/* CTA */}
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        size="large"
                                        sx={{ mt: 3 }}
                                        onClick={() => setOpenUpgradeModal(false)}
                                    >
                                        Apply Upgrades
                                    </Button>
                                </Box>
                            </Fade>
                        </Modal>



                        <h3 className="traveller-title">Travellers</h3>

                        <div className="traveller-flex">
                            {/* Adults */}
                            <FormControl fullWidth>
                                <InputLabel>Adult(4+yrs)</InputLabel>
                                <Select
                                    value={adults}
                                    label="Adult(4+yrs)"
                                    onChange={(e) => setAdults(Number(e.target.value))}
                                >
                                    {[...Array(50)].map((_, i) => (
                                        <MenuItem key={i + 1} value={i + 1}>
                                            {i + 1}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* Children */}
                            <FormControl fullWidth>
                                <InputLabel>Child(0-4 yrs)</InputLabel>
                                <Select
                                    value={children}
                                    label="Child(0-4 yrs)"
                                    onChange={(e) => setChildren(Number(e.target.value))}
                                >
                                    {[...Array(51)].map((_, i) => (
                                        <MenuItem key={i} value={i}>
                                            {i}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>


                    {/* Itinerary Accordion */}
                    {/* <div className="day-accordion">
                        {itininerary.map((item, index) => (
                            <div key={index} className="day-item">
                                <div className="day-header" onClick={() => toggleDay(index)}>
                                    <span>{item.name}</span>
                                    {activeIndex === index ? (
                                        <FaChevronUp className="day-icon" />
                                    ) : (
                                        <FaChevronDown className="day-icon" />
                                    )}
                                </div>
                                {activeIndex === index && (
                                    <div className="day-content">
                                        <p>
                                            <SafeComponent html={item?.description} />
                                        </p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div> */}

                    <div
                        style={{
                            width: "100%",
                            fontFamily: "Quicksand, sans-serif",
                            backgroundColor: "#ffff",
                            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            margin: "auto",
                            padding: "5%",
                            borderRadius: "10px",
                        }}
                    >
                        <h2 style={{ textAlign: "center", marginBottom: "1rem", fontFamily: "Gill Sans, sans-serif", fontSize: "1.5rem" }}>
                            Day Wise <strong>Itinerary</strong>
                        </h2>

                        {itininerary?.map((day, index) => (
                            <Accordion key={index} defaultExpanded sx={{ marginBottom: "10px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;" }}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel-${index}-content`}
                                    id={`panel-${index}-header`}
                                >
                                    <Typography fontWeight="bold">
                                        DAY {index + 1} – {day?.name}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails>
                                    <ul style={{ paddingLeft: "20px", margin: 0 }}>
                                        {day.description
                                            ?.replace(/&nbsp;/gi, " ")          // remove &nbsp;
                                            ?.replace(/&ndash;/gi, " ")          // remove &nbsp;
                                            ?.replace(/&amp; /gi, " ")          // remove &nbsp;
                                            ?.replace(/<\/?p>/g, "\n")          // replace <p> with new line
                                            ?.replace(/<br\s*\/?>/gi, "\n")     // handle <br> tags
                                            ?.replace(/<[^>]+>/g, "")           // remove all other HTML tags
                                            // ?.replace(/\s+/g, " ")              
                                            ?.split("\n")
                                            ?.map(line => line.trim())
                                            ?.filter(line => line !== "")
                                            ?.map((line, i) => (
                                                <li key={i} style={{ marginBottom: "8px" }}>
                                                    {line}
                                                </li>
                                            ))}
                                    </ul>

                                    {/* Optional Meal Info */}
                                    
        <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
          {day?.breakfast && <span>🍽️ Breakfast</span>}
          {day?.lunch && <span>🍽️ Lunch</span>}
          {day?.dinner && <span>🍽️ Dinner</span>}
        </div>
       
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </div>



                    {/* Map */}
                    <div
                        style={{
                            width: "100%",
                            margin: "0 auto",
                            borderRadius: "12px",
                            overflow: "hidden",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                        }}
                    >
                        {/* <h3 style={{ padding: "4px" }}>View In map</h3> */}
                        <SafeMap mapHtml={tourData?.destination?.map} />
                    </div>
                </div>
            </div>

            <div className="activity-slider-container" ref={activitySectionRef}>
                <h3 className="activity-slider-title">{activities.length > 0 && "Add Popular Activities"}</h3>

                <Slider {...activitySlider}>
                    {activities.map((activity) => (
                        <div className="activity-card" key={activity.id}>
                            <div className="activity-card-img-wrapper">
                                <img
                                    src={activity.image_url}
                                    alt={activity.name}
                                    className="activity-card-img"
                                />
                                <div className="activity-card-overlay">
                                    <h3 className="activity-card-name">{activity.name}</h3>
                                    <p className="activity-card-price">₹{activity.price}</p>
                                </div>
                            </div>

                            <div className="activity-card-footer">
                                {seatCounts[activity.id] > 0 ? (
                                    <div className="seat-counter">
                                        <button
                                            className="seat-btn"
                                            onClick={() => handleRemoveClick(activity.id)}
                                        >
                                            –
                                        </button>
                                        <span>{seatCounts[activity.id]}</span>
                                        <button
                                            className="seat-btn"
                                            onClick={() => handleAddClick(activity.id)}
                                        >
                                            +
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        className="activity-add-btn"
                                        onClick={() => handleAddClick(activity.id)}
                                    >
                                        Add
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>






<Modal
    open={openPassengerModal}
    onClose={(event, reason) => {
        if (reason !== "backdropClick") {
            setOpenPassengerModal(false);
        }
    }}
    closeAfterTransition
    BackdropComponent={Backdrop}
    BackdropProps={{ timeout: 500 }}
>
                <Fade in={openPassengerModal}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: { xs: "90%", sm: "450px" },
                            maxHeight: "85vh",
                            overflowY: "auto",
                            bgcolor: "background.paper",
                            borderRadius: 2,
                            boxShadow: 24,
                            p: 3,
                            "&::-webkit-scrollbar": { width: "6px" },
                            "&::-webkit-scrollbar-track": { background: "#f0f0f0", borderRadius: "10px" },
                            "&::-webkit-scrollbar-thumb": { background: "#b5b5b5", borderRadius: "10px" },
                            "&::-webkit-scrollbar-thumb:hover": { background: "#9e9e9e" },
                        }}
                    >
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h6" onClick={handleConfirmBooking}>Confirm Booking Details</Typography>
                            <IconButton onClick={() => setOpenPassengerModal(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        <Box sx={{ mt: 2, p: 2, border: "1px solid #ccc", borderRadius: 1 }}>
                            {/* <Typography variant="subtitle1"><b>Package:</b> {selectedPackage}</Typography> */}
                            <Typography variant="subtitle1"><b>Start Date:</b> {selectedDate?.format("DD/MM/YYYY")}</Typography>
                            <Typography variant="subtitle1">
                                <b>Travellers:</b> {adults} Adults, {children} Children
                            </Typography>
                            <Typography variant="subtitle1"><b>Activity Price:</b> ₹{activityPrice}</Typography>
                            <Typography variant="subtitle1">
                                <b>Upgrade Price:</b> ₹{calculateUpgradeTotal()}
                            </Typography>

                            <Typography variant="subtitle1"><b>Total Price:</b> ₹{finalPrice}</Typography>
                            <Typography variant="subtitle1"><b>Number of Days:</b> {tourData?.no_of_days}</Typography>
                        </Box>

                        <Typography variant="h6" sx={{ mb: 2, mt: 2 }}>
                            Passenger Details
                        </Typography>

                        {passengerDetails.map((p, index) => (
                            <Box key={index} sx={{ mb: 2, borderBottom: "1px solid #ddd", pb: 2 }}>
                                <Typography sx={{ mb: 1 }}>Passenger {index + 1}</Typography>

                                <TextField
                                    fullWidth
                                    label="Name"
                                    value={p.name}
                                    onChange={(e) => updatePassenger(index, "name", e.target.value)}
                                    sx={{ mb: 2 }}
                                    required
                                />

                                <TextField
                                    fullWidth
                                    label="Age"
                                    type="number"
                                    value={p.age}
                                    onChange={(e) => updatePassenger(index, "age", e.target.value)}
                                    sx={{ mb: 2 }}
                                    required
                                />

                                <FormControl fullWidth sx={{ mb: 2 }}>
                                    <InputLabel>Type</InputLabel>
                                    <Select
                                        value={p.type}
                                        label="Type"
                                        onChange={(e) => updatePassenger(index, "type", e.target.value)}
                                    >
                                        <MenuItem value="adult">Adult</MenuItem>
                                        <MenuItem value="child">Child</MenuItem>
                                        <MenuItem value="infant">Infant</MenuItem>
                                    </Select>
                                </FormControl>

                                {/* 🔥 Email - Required only for first passenger */}
                                <TextField
                                    fullWidth
                                    label="Email"
                                    type="email"
                                    value={p.email || ""}
                                    onChange={(e) => updatePassenger(index, "email", e.target.value)}
                                    sx={{ mb: 2 }}
                                    required={index === 0}
                                />

                                {/* 🔥 Phone - Required only for first passenger */}
                                <TextField
                                    fullWidth
                                    label="Phone"
                                    type="tel"
                                    value={p.phone || ""}
                                    onChange={(e) => updatePassenger(index, "phone", e.target.value)}
                                    required={index === 0}
                                />
                            </Box>
                        ))}


                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ mt: 2 }}
                            onClick={handleConfirmBooking}
                        >
                            Confirm Booking
                        </Button>

                    </Box>
                </Fade>
            </Modal>

            {showTopBtn && (
                <button
                    className="scrollTopBtn"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                    ↑
                </button>
            )}


        </div>
    )
}

export default PackageTourDetails